import { useMutation } from "@apollo/client";
import { UPDATE_DESIGNER_MATCHING_PROFILE } from "../../graphql/designer-matching-profile";

export const useUpdateDesignerMatchingProfileMutation = () => {
  const [updateDesignerMatchingProfile, { loading, error, data }] = useMutation(
    UPDATE_DESIGNER_MATCHING_PROFILE,
    {
      refetchQueries: ['GetDesignerStepStatus'],
      awaitRefetchQueries: true,
    }
  );

  const updateProfile = async (variables: {
    _id: string;
    personalityType?: string;
    stepCompletion?: any;
    expertise?: any;
    style?: any;
    workStyle?: any;
    preferences?: any;
  }) => {
    try {
      console.log("🔄 Updating designer matching profile with:", variables);
      const result = await updateDesignerMatchingProfile({
        variables
      });
      console.log("✅ Designer matching profile updated:", result);
      return result.data?.updateDesignerMatchingProfile;
    } catch (error) {
      console.error("❌ Error updating designer matching profile:", error);
      throw error;
    }
  };

  return {
    updateProfile,
    loading,
    error,
    data
  };
};
